let holdingSpace = false;

window.addEventListener('keyup', (event: KeyboardEvent) => {
    if (event.code === 'Space') {
        holdingSpace = false;
    }
});

window.addEventListener('keydown', (event: KeyboardEvent) => {
    if (event.code === 'Space' && (event.target === document.body || event.target instanceof HTMLAnchorElement) && (window as any).togglePlayPause) {
        event.preventDefault();

        if (holdingSpace) {
            return;
        }

        (window as any).togglePlayPause();
        holdingSpace = true;
    }
});
